/** Displays a Font-Awesome edit icon (fa-pencil) */
export const editIconFormatter = () => `<i class="fa fa-pencil pointer edit-icon" aria-hidden="true"></i>`;
//# sourceMappingURL=editIconFormatter.js.map